module.exports = __webpack_public_path__ + "img/link-icon.9bc94706.svg";